import { Component, OnInit } from '@angular/core'
import { HeaderComponent } from '../header/header.component'
import { ActivatedRoute, RouterLink } from '@angular/router'
import { MatButtonModule } from '@angular/material/button'

@Component({
    selector: 'app-success-marketing-desk',
    standalone: true,
    imports: [HeaderComponent, RouterLink, MatButtonModule],
    templateUrl: './success-marketing-desk.component.html',
    styleUrl: './success-marketing-desk.component.scss',
})
export class SRECSuccessComponent implements OnInit {
    refNumber: string | undefined

    constructor(private route: ActivatedRoute) {}

    ngOnInit() {
        this.route.queryParams.subscribe((params) => {
            this.refNumber = params['refNumber'] // read ref number from query params
        })
    }
}
